import axios from 'axios'
import Cookies from 'js-cookie';

let api = process.env.VUE_APP_API_URL

const axiosIns = axios.create({
  baseURL: api,
  withCredentials: true
})

axiosIns.interceptors.request.use((config) => {
  let token = Cookies.get('oliveiraToken')
  if (!token && typeof localStorage !== 'undefined') {
    const storedToken = localStorage.getItem('oliveiraToken')
    if (storedToken) {
      token = storedToken
      Cookies.set('oliveiraToken', storedToken, { expires: 7 })
    }
  }
  let locale = localStorage.getItem('psiqueasy-locale')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  if (locale) {
    if (locale == 'pt')
      locale = 'pt-br'
    config.headers.locale = locale
  }

  if ((
    config.method == 'post' ||
    config.method == 'put' ||
    config.method == 'delete'
  ) &&
    !Cookies.get('XSRF-TOKEN')) {
    return setCSRFToken()
      .then(response => config);
  }

  return config
}, (err) => {
  return Promise.reject(err)
})

const setCSRFToken = () => {
  return axiosIns.get('/csrf-cookie'); // resolves to '/api/csrf-cookie'.
}

const shouldSkipForceLogoutForUrl = (url = '') => {
  const normalizedUrl = String(url || '')
  return normalizedUrl.includes('/affiliate/')
    || /\/stores\/[^/]+\/affiliate\/profile/.test(normalizedUrl)
}

axiosIns.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response && error.response.status === 401) {
    const requestUrl = error.response?.config?.url || ''
    const skipForceLogout = Boolean(error.response?.config?.skipForceLogoutOn401)
      || shouldSkipForceLogoutForUrl(requestUrl)
    const isPreviewRoute = (typeof window !== 'undefined' && window.location && window.location.pathname.includes('/epub-preview')) ||
      (typeof localStorage !== 'undefined' && localStorage.getItem('ebook-preview'))

    const shouldForceLogout = () => {
      const token = Cookies.get('oliveiraToken')
      const message = error.response?.data?.message
      if (!token) return false
      if (!message) return false
      const normalizedMessage = String(message).toLowerCase()
      return normalizedMessage === 'unauthenticated.' || normalizedMessage === 'unauthenticated'
    }

    if (error.response.config && error.response.config.url) {
      console.warn('[axios][401]', error.response.config.url, {
        ...error.response?.data,
        skipForceLogout,
      })
      if (error.response.config.url.includes('/profile/addresses')) {
        return Promise.reject(error)
      }
    }

    if (!skipForceLogout && !isPreviewRoute && shouldForceLogout()) {
      Cookies.remove('oliveiraToken')
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('oliveiraToken')
      }
      window.location = '/'
    }
  }

  return Promise.reject(error)
})

export default axiosIns
